<template>
  <b-modal size="lg" id="new-business" title="New Business" hide-footer @shown="setupData" @hidden="clearData" body-class="pt-0">
    <b-form @submit.prevent="createBusiness">
      <h3 class="mb-4 text-center">$600/mo Enterprise Subscription will be added to your account.</h3>
      <b-row>
        <b-col md="6">
          <base-input label="Business Name" name="Business Name" placeholder="Business Name" v-model="enterprise.name" rules="required" />
          <b-row>
            <b-col>
              <base-input type="color" label="Primary Color" name="Primary Color" placeholder="Primary Color" v-model="enterprise.primary_color" rules="required" />
            </b-col>
            <b-col>
              <base-input type="color" label="Secondary Color" name="Secondary Color" placeholder="Secondary Color" v-model="enterprise.secondary_color" rules="required" />
            </b-col>
          </b-row>
          <div>
            <label class="form-control-label">Logo</label>
            <file-input @change="logoUpload"></file-input>
            <img :src="'https://vapor-us-east-1-1603342423.s3.amazonaws.com/' + enterprise.logo" class="w-100" v-if="enterprise.logo">
          </div>
        </b-col>
        <b-col md="6">
          <p class="text-center" v-if="payment_type == null"><strong>Select a payment option to continue.</strong></p>
          <b-button block class="mb-3" variant="primary" v-if="payment_type == null" @click="payment_type = 'existing'">Existing Payment Method</b-button>
          <b-button block variant="primary" v-if="payment_type == null" @click="payment_type = 'new'">New Payment Method</b-button>
          <b-button block variant="link" v-if="payment_type" @click="payment_type = null" class="mb-3"><i class="fas fa-angle-double-left"></i> Back</b-button>
          <b-list-group v-if="payment_type == 'existing'">
            <b-list-group-item class="d-flex justify-content-between" v-for="payment in payment_methods" :key="payment.id" @click="selectPaymentMethod(payment.id)">{{ payment.brand }} ending in {{ payment.last_four }}. <b-button size="sm" variant="primary">Select</b-button></b-list-group-item>
          </b-list-group>
          <div v-if="payment_type == 'new'">
            <b-row>
              <b-col>
                <label for="card-holder-name" class="sr-only sr-only-focusable">Name on Card</label>
                <base-input name="Name on Card"
                            placeholder="Card Holder Name"
                            rules="required"
                            v-model="name">
                </base-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div id="card-element" class="form-control"></div>
              </b-col>
            </b-row>
          </div>
          <b-button class="mt-3" block type="submit" variant="success" :disabled="disabled" v-if="payment_type">Submit</b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import {Select, Option} from 'element-ui';
import errorsMixin from "@/mixins/errors-mixin";
import FileInput from '@/components/Inputs/FileInput';

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    FileInput
  },
  data() {
    return {
      enterprise: {
        name: '',
        primary_color: '#000000',
        secondary_color: '#000000'
      },
      file: [],
      stripeAPIToken: '',
      intentToken: '',
      stripe: '',
      elements: '',
      card: '',
      plan: null,
      products: [],
      promocode: null,
      coupon: null,
      valid_coupon: null,
      payment_type: null,
      name: null,
      payment_methods: [],
      payment_method: null,
      disabled: true,
    }
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute',
    })
  },
  methods: {
    async getPlans() {
      axios.get(process.env.VUE_APP_API_BASE_URL + "/active-plans/enterprise")
      .then(response => {
        this.products = response.data.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    createBusiness() {
      let formData = new FormData();

      formData.append('name', this.enterprise.name);
      formData.append('primary_color', this.enterprise.primary_color);
      formData.append('secondary_color', this.enterprise.secondary_color);

      if (this.file.length > 0) {
        formData.append('file', this.file[0]);
      }

      axios.post(this.userRoute + "/register/new-enterprise", this.form)
      .then(response => {
        swal.fire({
          title: `Success`,
          text: 'New Business Created Successfully',
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          
        });
      })
      .catch(error => {

      });
    },
    async getPaymentMethods() {
      axios.get(this.userRoute + "/payments")
        .then(response => {
          this.payment_methods = response.data;
        })
        .catch(error => {
          this.error(error);
        });
    },
    setupData() {
      this.getPlans();
      this.getPaymentMethods();
      this.getStripeKey();
    },
    clearData() {
      this.enterprise = {
        name: '',
        primary_color: '',
        secondary_color: ''
      };

      this.file = [];
      this.plan = null;
      this.coupon = null;
    },
    logoUpload(logo) {
      this.file = logo;
    },
    selectPaymentMethod(payment) {
      this.payment_method = payment;
      this.disabled = false;
    },
    async getStripeKey() {
      axios.get(process.env.VUE_APP_API_BASE_URL + '/stripe-key')
      .then(response => {
        this.stripeAPIToken = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    includeStripe(URL, callback){
      let documentTag = document, tag = 'script',
          object = documentTag.createElement(tag),
          scriptTag = documentTag.getElementsByTagName(tag)[0];
      object.src = '//' + URL;
      if (callback) { object.addEventListener('load', function (e) { callback(null, e); }, false); }
      scriptTag.parentNode.insertBefore(object, scriptTag);
    },
    configureStripe(){
      this.stripe = Stripe(this.stripeAPIToken);

      this.elements = this.stripe.elements();
      this.card = this.elements.create('card');

      this.card.mount('#card-element');
    },
    async submitPaymentMethod() {
      this.paymentDisabled = true;
      this.addPaymentStatus = 1;

      this.stripe.confirmCardSetup(
        this.intentToken.client_secret, {
          payment_method: {
            card: this.card,
            billing_details: {
                name: this.name
            }
          }
        }
      ).then(result => {
        if (result.error) {
          this.addPaymentStatus = 3;
          this.addPaymentStatusError = result.error.message;
          this.disabled = false;
        } else {
          this.payment_method = result.setupIntent.payment_method;
          this.subscribe();
        }
      });
    },
  },
  watch: {
    payment_type(to, from) {
      if (to == 'new') {
        this.includeStripe('js.stripe.com/v3/', function(){
          this.configureStripe();
        }.bind(this));
      }
    }
  }
};
</script>